import { ISurcharge, SurchargeType } from "@evennt-tech/api-v2-core";
import {
  calculatePaymentFeeAmount,
  calculatePlatformFeeAmount,
  calculateProductPrice,
  calculateProductPriceWithFees,
} from "hooks/helpers";
import { ProductConfig, ShowProductConfig } from "ts/api/product";

type ExpandCustomConfig = (
  config: ProductConfig,
  params: {
    defaultPrice: number;
    defaultShowPrice?: number;
    supplierFee: number;
    organiserFee: number;
    paymentFee?: number;
    buildUp: Date;
    surcharges: ISurcharge[];
  }
) => ShowProductConfig;

export type ExpendCustomConfigParams = Parameters<ExpandCustomConfig>[1];

const expandCustomConfig: ExpandCustomConfig = (
  config,
  {
    defaultShowPrice,
    defaultPrice,
    surcharges,
    supplierFee,
    organiserFee,
    buildUp,
    paymentFee,
  }
) => {
  const productPrice = defaultPrice + config.priceUplift;
  const showPrice = defaultShowPrice
    ? defaultShowPrice + config.priceUplift
    : undefined;
  const calculatedPrice = calculateProductPrice(
    buildUp,
    surcharges,
    productPrice,
    showPrice
  );
  const price =
    calculatedPrice === SurchargeType.unpublish ? null : calculatedPrice;
  const priceWithFees =
    price !== null
      ? calculateProductPriceWithFees(price, organiserFee, supplierFee)
      : 0;
  const platformFeeAmount =
    organiserFee && price
      ? calculatePlatformFeeAmount(price, organiserFee)
      : null;
  const paymentFeeAmount =
    paymentFee && price ? calculatePaymentFeeAmount(price, paymentFee) : null;

  // `config` is already parsed for the current show — cpoConfigOverrides[0]
  // would be an arbitrary show's row.
  const purchasedQuantity = config.purchasedQuantity ?? 0;
  return {
    ...config,
    price,
    priceWithFees,
    ...(platformFeeAmount !== null && { platformFeeAmount }),
    paymentFeeAmount,
    purchasedQuantity,
  };
};

export default expandCustomConfig;
